"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "allNetworks", {
  enumerable: true,
  get: function () {
    return _networks.allNetworks;
  }
});
Object.defineProperty(exports, "availableNetworks", {
  enumerable: true,
  get: function () {
    return _networks.availableNetworks;
  }
});
Object.defineProperty(exports, "selectableNetworks", {
  enumerable: true,
  get: function () {
    return _networks.selectableNetworks;
  }
});
var _networks = require("@polkadot/networks");